import React, {Component} from 'react';
import LazyImage from './LazyImage'
import uuid from 'uuid'
import {styles} from '../../config'

class Carousel extends Component {
	constructor(props) {
		super(props)
		this.uuid = uuid.v4()
		this.state = {
			current: -1,
			prev: -1,
			next: -1,
			prevpos: -1,
			items: [],
			aspect: []
		}
		this.aspect = 0
	}
	
	componentWillUnmount() {
		this.unmounted = true
	}
	componentWillMount() {
		const {current, items} = this.props
		this.setState({items: items.map(i => undefined)})
		if(current===undefined || current<0) this.setState({current:-1, next:-1, prev: -1})
		else this.setCurrent(current, items)
	}
	componentWillReceiveProps(nextProps) {
		const {current, items} = nextProps
		if (items!==this.props.items) {
			this.setState({items: items.map(i => undefined)})
			if(current===undefined || current<0) this.setState({current:-1, next:-1, prev: -1})
			else this.setCurrent(current, items)
			return
		}
		if(current===undefined || current<0) {
			this.setState({current:-1, next:-1, prev: -1})
			return
		}
		if(current!==this.props.current) {
			this.setCurrent(current, items)
		}
	}
	setCurrent = (current, items) => {
		let p = current - 1
		if (p<0) p = items.length - 1
		let n = current + 1
		if (n===items.length) n = 0
		let newItems = [...this.state.items]
		newItems[current] = items[current]
		newItems[p] = items[p]
		newItems[n] = items[n]
		this.setState({current, next: n, prev: p, items: newItems})
	}
	prev = () => {
		const {items} = this.props
		const {current} = this.state
		let p = current-1
		if (p<0) p = items.length - 1
		if(!this.state.items[p]) {
			let newItems = [...this.state.items]
			newItems[p] = items[p]
			this.setState({items: newItems})
		}
		this.setState({prevpos: p, next:-1})
		setTimeout(() => {
			this.setState({prevpos:-1, current: p, prev: -1, next: current})
		})
		
	}
	
	next = () => {
		const {items} = this.props
		const {current} = this.state
		let n = current + 1
		if (n===items.length) n = 0
		if(!this.state.items[n]) {
			let newItems = [...this.state.items]
			newItems[n] = items[n]
			this.setState({items: newItems})
		}
		this.setState({prev: -1, next: -1})
		setTimeout(() => {
			this.setState({prev: current, current: n, next: -1})
		})
		
	}
	changeCurrent = e => {
		const {items} = this.props
		const n = parseInt(e.currentTarget.getAttribute('data-index'), 10)

		if(!this.state.items[n]) {
			let newItems = [...this.state.items]
			newItems[n] = items[n]
			this.setState({items: newItems})
		}

		this.setState({prevpos:-1, next: -1, prev: -1})
		setTimeout(() => {
			this.setState({prev: this.state.current, current:n})
		})
	}
	onAspectChange = (aspect, real, index) => {
		const {heightFixed} = this.props
		if(heightFixed) return
		if(!real) return
		
		let a = [...this.state.aspect]
		a[index] = aspect
		this.setState({aspect: a})
	}

	render() {
		const {proportional, heightFixed, mq, o, imageStyle} = this.props
		const {items, prevpos, prev, current, next} = this.state
		let trackStyle = {}
		if(!heightFixed && current>=0) {
			//let a = aspect[current]?aspect[current]:this.aspect
			//console.log(items)
			let a = (imageStyle
					?(styles[imageStyle][1]/styles[imageStyle][0]*100)
					:(items[current].h / items[current].w * 100)) + '%'
			this.aspect = a
			trackStyle = {
				height: 0,
				paddingBottom: a
			}
		}
		return (
	<div className={'carousel'+ (proportional?' proportional':'')+ (heightFixed?' height-fixed':'')} id={`carousel-${this.uuid}`}>
			<div className="carousel-track" style={trackStyle}>
       				{items.map((item, i) => 
   						<div key={i} 
   							className={'carousel-item' + 
   								(i===current?' active':'') + 
   								(i===prevpos?' prevpos':'') + 
   								(i===prev?' prev':'') + 
   								(i===next?' next':'')}>
   							{item &&
   							<LazyImage index={i}
   								imageStyle={imageStyle}
   								src={item} alt='' bg={true} proportional={proportional} 
   								onAspectChange={this.onAspectChange}
   								 mq={mq} o={o}/>
   							}
   						</div>
       				)}
       				<div className='carousel-pager'>
       					{this.props.items.map((item, i) => <div key={i} className={i===current?'active':''} data-index={i} onClick={this.changeCurrent}/>)}
       				</div>
  				<nav className="pager-controls">
    			<a
      				className="pager-control prev"
      				onClick={() => this.prev()}
    			>
      			<i className='fa fa-angle-left'/>
    			</a>
    			<a
      				className="pager-control next"
      				onClick={() => this.next()}
    			>
      			<i className='fa fa-angle-right'/>
    			</a>
  				</nav>
  				
			</div>
    </div>
		)
	}
}
export default Carousel;



// WEBPACK FOOTER //
// ./src/fm/lib/Carousel.js